import React, { useState, useCallback } from "react";
import connect from "Shared/connect";
import FeedbackButton from "Shared/Button/Feedback";
import Modal from "Shared/Modal";
import { translate } from "Shared/translate";
import LoginContainer from "Shared/Login/Container";
import { fetchShoppinglist } from "./action-creators";
import ShoppingList from "./ShoppingList";
import * as styles from "./Pages/page.scss";
const AddRecipeToCart = (props) => {
    const [isOpen, setOpen] = useState(false);
    const [shoppingList, setShoppingList] = useState(null);
    const handleClose = useCallback(() => setOpen(false), []);
    const handleGetShoppingList = useCallback(() => {
        return props.fetchShoppinglist(props.portions).then((result) => {
            setShoppingList(result);
            setOpen(true);
        });
    }, [
        shoppingList,
        props.fetchShoppinglist,
        props.portions,
        setShoppingList,
        setOpen,
    ]);
    return (React.createElement(LoginContainer, null, ({ isLoggedIn }) => isLoggedIn ? (React.createElement("div", { onClick: (e) => e.stopPropagation() },
        React.createElement(FeedbackButton, { appearance: "secondary", onClickWithFeedback: (e, activate) => activate(handleGetShoppingList()), disabled: props.isRestrictedCustomer }, translate("/AddOrder/AddToCart")),
        shoppingList && (React.createElement(Modal, { title: translate("/Recipe/ShoppingList", shoppingList.recipeName), isOpen: isOpen, onClose: handleClose, className: styles.addRecipeToCartModal },
            React.createElement(ShoppingList, Object.assign({}, shoppingList, { hideModal: handleClose })))))) : null));
};
export default connect((state) => ({
    isRestrictedCustomer: state.appShellData.currentUser.isRestrictedCustomer,
}), (dispatch) => ({
    fetchShoppinglist: (portion) => dispatch(fetchShoppinglist(portion)),
}))(AddRecipeToCart);
